<template>
  <div class="accordion">
    <div class="accordion_header" @click="toggle" :class="this.AccordionClassList">
      <slot name="header">Default header</slot>
    </div>
    <transition name="accordion" v-on:before-enter="beforeEnter" v-on:enter="enter" v-on:before-leave="beforeLeave" v-on:leave="leave">
      <div class="accordion_body" v-if="show">
        <div class="accordion_body_inner">
          <slot name="body"></slot>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  data() {
    return {
      show: this.initialShow,
      options: {
        container: '',
        easing: 'ease-in',
        offset: -60,
        force: true,
        cancelable: true,
        x: false,
        y: true
      }
    };
  },
  props: {
    id: Number,
    group: String,
    showed: Boolean,
    initialShow: Boolean
  },
  computed: {
    ...mapState(['userAgent', 'currentPage']),
    AccordionClassList() {
      return {
        'rotate': this.show,
      };
    },
    isIE() {
      return this.userAgent.browser.name === 'ie';
    },
  },
  mounted() {
    let self = this;
    window.removeEventListener('accordion', function (e) {
      self.toggleAccordion(e);
    });
    window.addEventListener('accordion', function (e) {
      self.toggleAccordion(e);
    });
  },
  destroyed() {
    window.removeEventListener('accordion', function (e) {
      self.toggleAccordion(e);
    });
  },
  methods: {
    toggle: function () {
      window.dispatchEvent(new CustomEvent('accordion', {
        detail: {
          id: this.id,
          group: this.group,
          activeStatus: this.show
        }
      }));
    },
    toggleAccordion: function (acc) {
      let self = this;
      if (this.$route.query.screentest) {
        self.show = !self.show;
      } else {
        let self = this;
        if (acc.detail.group === self.group) {
          if (acc.detail.id === self.id) {
            self.show = !self.show;
            setTimeout(() => {
              var elementTop = self.$vnode.elm.offsetTop;
              if ((elementTop < window.pageYOffset) && elementTop !== 0) {
                this.$scrollTo(self.$vnode.elm, 300, this.options);
              }
            }, 60);
          } else {
            self.show = false;
          }
        }
      }
    },
    beforeEnter: function (el) {
      el.style.height = '0';
      el.style.minHeight = '0';
    },
    enter: function (el) {
      let shift = 20;
      if (this.userAgent.window.width < 768) {
        shift = 0;
      }
      el.style.height = el.scrollHeight + shift + 'px';
      setTimeout(() => {
        el.style.height = el.scrollHeight + shift + 'px';
      }, 100);
      setTimeout(() => {
        el.style.minHeight = el.scrollHeight + 'px';
      }, 1000);
    },
    beforeLeave: function (el) {
      let shift = 20;
      if (this.userAgent.window.width < 768) {
        shift = 0;
      }
      el.style.height = el.scrollHeight + shift + 'px';
    },
    leave: function (el) {
      el.style.height = '0';
      el.style.minHeight = '0';
    }
  },
  watch: {}
};
</script>

<style lang="scss">
.accordion {
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  margin-bottom: 25px;

  .accordion_header {
    position: relative;
    display: flex;
    width: 100%;
    align-items: center;
    justify-content: space-between;
    padding: 10px 35px;
    //
    border: solid 2px #c7d0dc;
    border-radius: 4px;
    transition: all .3s linear;

    &:hover {
      cursor: pointer;
      border-color: #97a7c3;

      .accordion_title {
        transition: all .3s linear;
        color: #3c5b94;
      }
    }

    @include media("<tablet") {
      padding: 10px 20px;
    }
  }

  .accordion_body {
    width: 100%;
    display: flex;
    flex-direction: row;
    overflow: hidden;
    transition: height 0.3s ease-in-out;
    @include media("<phone") {
      transition: none;
    }
  }
}

.accordion_body_inner {
  width: 100%;
  padding: 30px 0 0 0;
}

// TEXT
.accordion_title {
  font-family: 'Roboto Condensed', sans-serif;
  font-size: 21px;
  font-weight: bold;
  font-stretch: condensed;
  font-style: normal;
  line-height: 1.62;
  letter-spacing: normal;
  color: #1c3460;

  @include media("<tablet") {
    font-size: 18px;
    line-height: 1.2;
  }
}

.accordion-toggle {
  transition: transform .3s linear;
  margin-left: 10px;

  .rotate & {
    transform: rotate(-180deg);
  }
}

// ANIMATIONS
.accordion-enter-active {
  transition: opacity .5s;
}

.accordion-enter {
  opacity: 0;
}

</style>
